import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './WebFooter.module.scss'
import { NoCursorFightbackLogoImage } from '../icon/Icon'
import { DesktopTitleLarge } from '../../Typography'
import { ROUTES } from '../../config/routes'
import { URLS } from '../../content/urls'

export const WebFooter = (): ReactElement => {
  const navigate = useNavigate()

  return (
    <div>
      <footer className={styles.footer}>
        <div className={styles.logoBox}>{NoCursorFightbackLogoImage}</div>
        <div className={styles.linkBox}>
          <DesktopTitleLarge
            className={styles.link}
            darkFont={true}
            onClick={(): void => {
              navigate(ROUTES.impressum)
            }}
          >
            Impressum
          </DesktopTitleLarge>
          <DesktopTitleLarge
            className={styles.link}
            darkFont={true}
            onClick={(): void => {
              navigate(ROUTES.datenschutz)
            }}
          >
            Datenschutz
          </DesktopTitleLarge>
          <a href={URLS.oktv} target='_blank' rel='noreferrer'>
            OKTV Mainz
          </a>
          <a href={URLS.slWrestling} target='_blank' rel='noreferrer'>
            Merchandise
          </a>
          <a href={URLS.linktree} target='_blank' rel='noreferrer'>
            Linktree
          </a>
        </div>
        <div className={styles.logoBox}>{NoCursorFightbackLogoImage}</div>
      </footer>
    </div>
  )
}
